import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { AbsoluteBackgroundImage } from 'enums/absolute-background-image';
import { useUIContext } from 'state/ui';

import {
  AddIcon,
  AddToCardBtn,
  AddToCardBtnText,
  BtnContainer,
  CardContent,
  Container,
  EditIcon,
  ExclamationIcon,
  IconBtn,
  Image,
  Name,
  NotAvailableText,
  ProductImg,
} from './styled';
import { IRecentOrderCardProps } from './types';

const RecentOrderCard: FC<IRecentOrderCardProps> = ({
  productImage,
  backgroundImage,
  showEdit = false,
  isAvailable,
  marginRight = '0',
  name,
  addToCartOnClick,
  editItemOnClick,
  ariaLabel,
}) => {
  const { buildImageUrl } = useUIContext();
  const { formatMessage } = useIntl();

  let buttonContent = (
    <AddToCardBtn
      onClick={addToCartOnClick}
      data-testid="single-add-to-cart-btn"
      aria-label={ariaLabel}
    >
      <AddIcon />
      <AddToCardBtnText>{formatMessage({ id: 'addToCart' })}</AddToCardBtnText>
    </AddToCardBtn>
  );
  if (showEdit) {
    buttonContent = (
      <>
        <IconBtn onClick={addToCartOnClick} data-testid="add-to-cart-btn">
          <AddIcon />
        </IconBtn>
        <IconBtn onClick={editItemOnClick} data-testid="edit-btn">
          <EditIcon />
        </IconBtn>
      </>
    );
  }
  if (!isAvailable) {
    buttonContent = (
      <NotAvailableText data-testid="not-available-in-store">
        <ExclamationIcon>!</ExclamationIcon>
        <span>{formatMessage({ id: 'notAvailableAtStore' })}</span>
      </NotAvailableText>
    );
  }
  return (
    <Container marginRight={marginRight}>
      <Image
        backgroundImageUrl={
          backgroundImage && backgroundImage.asset
            ? buildImageUrl(backgroundImage, {
                width: AbsoluteBackgroundImage.WIDTH,
                height: AbsoluteBackgroundImage.HEIGHT,
                format: 'jpg',
              })
            : ''
        }
      >
        <ProductImg image={productImage} alt={name} />
      </Image>
      <CardContent>
        <Name isAvailable={isAvailable}>{name}</Name>
        <BtnContainer>{buttonContent}</BtnContainer>
      </CardContent>
    </Container>
  );
};

export default RecentOrderCard;
